import { render } from "./AddExchange.vue?vue&type=template&id=2e1b66f6&scoped=true"
import script from "./AddExchange.vue?vue&type=script&lang=js"
export * from "./AddExchange.vue?vue&type=script&lang=js"

import "./AddExchange.vue?vue&type=style&index=0&id=2e1b66f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e1b66f6"]])

export default __exports__